import { Backdrop, CircularProgress } from '@mui/material';

const displayLoadingIndicator = (isEstimateScreen) => {
    return (
        <div>
            <Backdrop
                sx={{
                    color: '#fff',
                    zIndex: (theme) => theme.zIndex.drawer + 1,
                    'flex-direction': 'column',
                }}
                open={true}
                {...(isEstimateScreen
                    ? { 'aria-live': 'polite', 'aria-label': 'Calculating estimates' }
                    : {})}
            >
                {isEstimateScreen ? <h2>Calculating your personalized cost estimate...</h2> : null}
                <CircularProgress color="inherit" />
            </Backdrop>
        </div>
    );
};

export default displayLoadingIndicator;
